import { useCallback, useState } from "react"

function useForceUpdate() {
  const [, setState] = useState()

  const forceUpdate = useCallback(() => {
    setState({})
  }, [])

  return forceUpdate
}

export default useForceUpdate
